var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 26,
    viewBox: "0 0 22 26",
    width: 22,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-5 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    transform: "translate(6.666667 4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.8853333 4.552-3.7706666-3.77066667c-.5-.5-1.1786667-.78133333-1.8853334-.78133333h-9.56266663c-1.47333334 0-2.66666667 1.19333333-2.66666667 2.66666667v18.66666663c0 1.4733334 1.19333333 2.6666667 2.66666667 2.6666667h13.33333333c1.4733333 0 2.6666667-1.1933333 2.6666667-2.6666667v-14.89599997c0-.70666666-.2813334-1.38533333-.7813334-1.88533333z",
    fill: "#181818",
    fillOpacity: 0.030622
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.6666667 6.66666667h-5.3333334c-.736 0-1.3333333-.59733334-1.3333333-1.33333334v-5.33333333"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h32v32h-32z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.9b32465ee09a7c6d8a2d3df259f598da.svg";
export { ForwardRef as ReactComponent };